<template>
  <div class="mt-2">
    <v-alert
      border="top"
      color="red lighten-2"
      dark>
      <h2>{{$t('page_not_found')}} (404)</h2>
      <hr class="my-3">
      <span v-html="$t('404_error_message')"></span>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: 'NotFound.vue'
}
</script>

<style scoped>
</style>
